import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { TONE_CLASS, type Tone } from "@/lib/status";
import { cn } from "@/lib/utils";

export interface StatusBadgeProps {
  tone: Tone;
  label: ReactNode;
  icon?: LucideIcon;
  spin?: boolean;
  size?: "sm" | "md";
  outline?: boolean;
  className?: string;
  description?: string;
}

export function StatusBadge({ tone, label, icon: Icon, spin, size = "sm", outline, className, description }: StatusBadgeProps) {
  return (
    <span
      data-slot="status-badge"
      aria-description={description}
      className={cn(
        "inline-flex max-w-full items-center gap-1.5 whitespace-nowrap rounded-full border font-medium",
        size === "sm" ? "h-6 px-2 text-xs" : "h-7 px-2.5 text-sm",
        outline ? "bg-transparent" : "",
        TONE_CLASS[tone],
        className,
      )}
    >
      {Icon && <Icon aria-hidden className={cn("size-3.5 shrink-0", spin && "animate-spin")} />}
      <span className="truncate">{label}</span>
    </span>
  );
}
